//@ts-nocheck
import * as React from 'react';
import { aggUniversityAlternateName, getStateAbbr } from '../../Common/Helpers';

class StateLegislativeMaps extends React.Component<Props, {}> {

    renderMap(imgSrc) {
        if (imgSrc) {
            return <div style={{ height: '500px', width: '100%', overflow: 'hidden' }}>
                <img src={imgSrc} style={{ margin: '0 auto', objectFit: "contain", maxWidth: '100%', maxHeight: '100%', display: 'block' }}></img>
            </div>
        } else {
            return <div className="loading">loading <i className="fa fa-spinner"></i></div>;
        }
    }

    render() {
        const { university, start_year, current_year, latest_map, range_map, title_text, state} = this.props;
        return (<div>
            <div className="row">
                <div className="col-md-12">
                    <h3>Spending on Research-Related Goods and Services from Sponsored Projects at<br />{aggUniversityAlternateName(university)}, by {title_text} ({getStateAbbr(state)}), FY {current_year}</h3>
                    {this.renderMap(latest_map)}
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <h3>Spending on Research-Related Goods and Services from Sponsored Projects at<br />{aggUniversityAlternateName(university)}, by {title_text} ({getStateAbbr(state)}), FY {start_year}-{current_year}</h3>
                    {this.renderMap(range_map)}
                </div>
            </div>
        </div>);
    }
}

export default StateLegislativeMaps;
